function initialize(root = document) {
  const filter = root.querySelector('[data-global-loja-filter]')
  if (!filter) return

  const configuration = root.querySelector('#focus_nfe-tab-pane')
  const activation = root.querySelector('[data-nota-fiscal-activation-context]')
  const localContext = !!activation || !!(configuration && configuration.classList.contains('active'))
  filter.hidden = localContext
  filter.classList.toggle('d-none', localContext)
}

module.exports = { initialize }
